import React, { useEffect, useState } from 'react';
import Layout from '../../../components/Layout/Layout';
import LcDropDown from '../../../components/Generic/LcDropDown';
import LcInfiniteTable from '../../../components/Data/LcInfiniteTable';
import LcIconLink from '../../../components/Generic/LcIconLink';
import { AiOutlineApple, AiOutlineCheckCircle, AiOutlineExclamationCircle, AiOutlineWindows } from 'react-icons/ai';
import { PiLinuxLogo } from 'react-icons/pi';
import { PatchManagerService } from '../../../services/patchmanager/patchManagerService';
import { InstalledPatchDataModel, MissingPatchDataModel, PatchDataModel, PatchDatailModel, SystemDetail, TopPriorityPatchDataModel } from '../../../services/patchmanager/patchManagerModel';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';
import { UserState } from '../../../store/reducers/userReducer';
import { PPModal } from 'processor-plataform-ui';
import LcLoading from '../../../components/Generic/LcLoading';
import { LiaBanSolid } from 'react-icons/lia';


const PatchListPathManager: React.FC = (props) => {

    const patchmanagerService = new PatchManagerService(props)
    const user = useSelector<RootState, UserState>(state => state.user);
    const [selectedPatch, setSelectedPatch] = useState<number>(2);
    const [rowsPatches, setRowsPatches] = useState<PatchDataModel[]>([]);
    const [rowsPatcheSelected, setRowsPatcheSelected] = useState<SystemDetail[]>([]);
    const [rowsInstalledPatcheSelected, setRowsInstalledPatcheSelected] = useState<InstalledPatchDataModel[]>([]);
    const [rowsMissingPatcheSelected, setRowsMissingPatcheSelected] = useState<MissingPatchDataModel[]>([]);
    const [rowsTopPriorityPatcheSelected, setRowsTopPriorityPatcheSelected] = useState<TopPriorityPatchDataModel[]>([]);
    const [openModal, setOpenModal] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false)
    const patchesOption = [{ label: 'Patches instalados', value: 2 },
        { label: 'Patches ausentes', value: 1 },
        
    ]
    const tranleteStatusColorRow = (status: PatchDataModel) => {
        const tranlateStatusColor = {
            'Important': '#ffa400',
            'Critical': "#dc291e",
            'High': "#dc291e",
            'Moderate': "#f6de00",
            'Medium': '#f6de00',
            'Low': "#3ebb3f",
            'Unclassified': "#cccccf",
        };
        return tranlateStatusColor[status.severity];
    }
    const tranleteStatusColorRowDetails = (status: PatchDatailModel) => {
        const tranlateStatusColor = {
            'Important': '#ffa400',
            'Critical': "#dc291e",
            'High': "#dc291e",
            'Medium': "#f6de00",
            'Moderate': "#f6de00",
            'Low': "#3ebb3f",
            'Unclassified': "#cccccf",
        };
        return tranlateStatusColor[status.patch_serverity];
    }
    const translateStatusColor = (status: string) => {
        const tranlateStatusColor = {
            'Important': '#ffa400',
            'Critical': "#dc291e",
            'High': "#dc291e",
            'Moderate': "#f6de00",
            'Medium': '#f6de00',
            'Low': "#3ebb3f",
            'Unclassified': "#cccccf",
        };
        return tranlateStatusColor[status];
    }
    const translateSeverityColor = (status: string) => {
        const tranlateStatusColor = {
            '4': '#ff4400', // 'Important'
            '3': '#ffa400', // 'Important'
            '2': "#f6de00",// 'Moderate' 
            '1': "#3ebb3f",//'Low'
            '0': "#cccccf",//'Unrated'
        };
        return tranlateStatusColor[status];
    }
    const translateSeverityLabel = (status: string) => {
        const tranlateStatusColor = {
              '4': 'Crítico'
            , '3': 'Important'
            , '2': 'Moderate'
            , '1': 'Low'
            , '0': 'Unrated'
        };
        return tranlateStatusColor[status];
    }

    const translateStatusLabel = (status: string) => {
        const tranleteStatusLabel = {
            'Important': 'Importante',
            'High': 'Alta',
            'Medium': 'Media',
            'Critical': "Crítico",
            'Moderate': "Moderado",
            'Low': "Baixo",
            'Unclassified': "Não Classificado",
        };
        return tranleteStatusLabel[status];
    }
    const translateStatusPatch = (status: string) => {
        const translateStatus = {
            '202': 'Ausente',
            '201': "Instalado",
            '206': "Falha"
        };
        return translateStatus[status];
    }
    const translateApprovalStatus = (status: string) => {
        const tranleteStatus = {
            'Approved': 'Aprovado',
            'Reproved': "Reprovado",

        };
        return tranleteStatus[status];
    }

    const missingColumns = [
        { field: "patchId", headerName: "Patch ID", width: "8%", align: 'center', },
        {
            field: "severity", headerName: "Severidade", width: "10%", align: 'center',
            renderCell: (row: PatchDataModel) => {
                return <div className='severityLabelDetails' style={{
                    padding: '0px 8px',
                    backgroundColor: translateSeverityColor(row.severity)
                }}>
                    {translateSeverityLabel(row.severity)}
                </div>
            }
        },
        { field: "patchName", headerName: "Nome do patch", width: "35%", align: 'left', hide: selectedPatch !== 2 },
        { field: "kbNumber", headerName: "Número KB", width: "10%", align: 'left', hide: selectedPatch !== 1 },
        {
            field: "patchDescription", headerName: "Descrição do patch", width: "20%", align: 'left', hide: selectedPatch !== 1,
            renderCell: (row: PatchDataModel) => <div className='overflowEllipsis'>{row.patchDescription}</div>
        },
        {
            field: "approveStatus", headerName: "Status de aprovação", width: "12%", align: 'center', hide: selectedPatch !== 3,
            renderCell: (row: PatchDataModel) => {
                return <div style={{ display: 'flex', alignItems: 'center', marginLeft: row.approveStatus === 'Reproved' ? '-6px' : '-10px' }} >
                    <LcIconLink icon={row.approveStatus === 'Reproved' ? <LiaBanSolid color='#dc291e' /> : <AiOutlineCheckCircle color='#3ebb3f' />} />
                    <span className={'ml-5'}>{translateApprovalStatus(row.approveStatus)}</span>
                </div>
            }
        },
        {
            field: "missingSystem", headerName: "Sistemas ausentes", width: "15%", align: 'center', hide: selectedPatch === 2,
            renderCell: (row: PatchDataModel) => <div onClick={() => {
                row.systemsDetail && setRowsPatcheSelected(row.systemsDetail);
                setOpenModal(true);
            }} style={{ color: '#00aee1', fontWeight: 600, cursor: 'pointer' }}>
                {row.missingSystem}
            </div>
        },
        {
            field: "failedSystem", headerName: "Sistemas com falha", width: "15%", align: 'center', hide: selectedPatch === 2,
            renderCell: (row: PatchDataModel) => <div onClick={() => {
                selectedPatch === 1 ? row.systemsDetail && setRowsPatcheSelected(row.systemsDetail) :
                    row.systemsDetail && setRowsPatcheSelected(row.systemsDetail);
                setOpenModal(true)
            }}
                style={{ color: '#00aee1', fontWeight: 600, cursor: 'pointer' }}>
                {row.failedSystem}
            </div>
        },
        {
            field: "installedSystems", headerName: "Sistemas instalados", width: "15%", align: 'center', hide: selectedPatch !== 2,
            renderCell: (row: PatchDataModel) => <div onClick={() => {
                setRowsPatcheSelected(row.systemsDetail);
                setOpenModal(true)
            }} style={{ color: '#00aee1', fontWeight: 600, cursor: 'pointer' }}>
                {row.installedSystems}
            </div>
        },
        {
            field: "platform", headerName: "Plataforma", width: "10%", align: 'left', hide: selectedPatch === 3,
            renderCell: (row: any) => {
                return (
                    <div style={{ display: 'flex', alignItems: 'center', marginLeft: '-6px' }}>
                        {row.platform && <LcIconLink icon={
                            row.platform.includes('Windows') ? <AiOutlineWindows size={'1rem'} />
                                :
                                row.platform.includes('mac') ? <AiOutlineApple size={'1rem'} />
                                    :
                                    <PiLinuxLogo size={'1rem'} />
                        } />}
                        <span>{row.platform}</span>
                    </div>
                )
            }
        },
        {
            field: "rebootRequired", headerName: "Reboot", width: "10%", align: 'center', overflow: "visible", hide: selectedPatch !== 1,
            renderCell: (row: any) => {
                return row.rebootRequired != "0" ?
                    <LcIconLink size='small'
                        icon={<AiOutlineExclamationCircle color='#ffb530' size={18} />}
                        tooltip="Necessário reiniciar a máquina"
                        tooltipPosition='right' 
                    /> : <div>-</div>
            }
        },
    ];

    const detailsPatches = [
        { field: "computerName", headerName: "Nome do Computador", width: "15%", align: 'left' },
        { field: "domain", headerName: "Domínio", width: "20%", align: 'center' },
        { field: "operatingSystem", headerName: "Sistema operacional", width: "30%", align: 'left' },
        { field: "patchId", headerName: "Patch Id", width: "10%", align: 'left' },
        { field: "patchStatus", headerName: "Status do instalação", width: "15%", align: 'left',
            renderCell: (row: SystemDetail) => {
                return (
                    <div style={{ display: 'flex', alignItems: 'center', marginLeft: '-6px' }} >
                        <LcIconLink icon={row.patchStatus === '202' ? <LiaBanSolid color='#dc291e' /> :
                            row.patchStatus.includes('INSTALL') ? <AiOutlineCheckCircle color='#3ebb3f' /> :
                                <AiOutlineExclamationCircle color='#ffa400' />} />
                        <span className='ml-5'>{translateStatusPatch(row.patchStatus)}</span>
                    </div>
                )
            }
        },
        { field: "patchServerity", headerName: "Severidade", width: "11%", align: 'center',
            renderCell: (row: SystemDetail) => {
                return <div className='severityLabelDetails ' style={{
                    padding: '0px 8px',
                    backgroundColor: translateSeverityColor(row.patchSeverity)
                }}>{translateSeverityLabel(row.patchSeverity)} </div>
            }
        }
    ]

    const getPatchesData = async () => {
        try { 
            if (selectedPatch === 1) {
                const patchRespose = await patchmanagerService.GetMissingPatchesData();
                setRowsMissingPatcheSelected(patchRespose);
            } else if (selectedPatch === 2) {
                const patchRespose = await patchmanagerService.GetInstalledPatchesData();
                setRowsInstalledPatcheSelected(patchRespose);
            } 

        } catch (error) {
            console.error(`Error: ${error}`)
        }
    }

    useEffect(() => {
        setLoading(true)
        getPatchesData()
            .finally(() =>
                setLoading(false));
    }, [user.ClientGroupSelected, user.refreshFlag, selectedPatch])

    return (
        <Layout
            cardType
            pageTitle='Patches'
            row={
                <LcDropDown
                    element={<span>{patchesOption.find(c => c.value === selectedPatch)?.label} <i className="ppi ppi-chevron-down" /></span>}
                    position="rigth"
                >
                    { patchesOption.map((ci, i) => {
                            return <div key={i} className={'item'}
                                onClick={() => {
                                    ci.value != selectedPatch &&
                                        setSelectedPatch(ci.value);
                                }}

                            >{ci.label}</div>
                        })
                    }
                </LcDropDown>
            }
        >
            <LcLoading loading={loading} label='Carregando Patches...' >
                <LcInfiniteTable
                    rows={selectedPatch === 1 ? rowsMissingPatcheSelected : selectedPatch === 2 ? rowsInstalledPatcheSelected : rowsTopPriorityPatcheSelected}
                    columns={missingColumns}
                    loadMore={(() => undefined)}
                    size={0}
                    hidePagination
                    fontSize='medium'
                    status={tranleteStatusColorRow}
                />
            </LcLoading>

            <PPModal visible={openModal} onClose={() => setOpenModal(false)} size='large' title="Detalhes do Patch">
                <LcInfiniteTable
                    rows={rowsPatcheSelected}
                    columns={detailsPatches}
                    loadMore={() => undefined}
                    size={rowsPatcheSelected.length}
                    hidePagination
                    status={tranleteStatusColorRowDetails}
                />
            </PPModal>
        </Layout>
    )
}

export default PatchListPathManager;